import React, { useState } from "react";
import styles from "./PreviewMultipleChoice.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { useDispatch } from "react-redux";
import { setSelectedOptionsForFormula } from "@redux/slices/scoringSlice";
import { capitalizeFirstLetter } from "utils/utils";
import { MenuItem, Select } from "@mui/material";

const PreviewMultipleChoice = (props) => {
  const [showIcon, setShowIcon] = useState(props?.data?.showInstructions || false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempSelectedOption, setTempSelectedOption] = useState("")
  const [tempSelectedOptions, setTempSelectedOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();

  const handleOptionChange = (option) => {
    setTempSelectedOptions((prev) => {
      const updatedOptions = prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, capitalizeFirstLetter(option)];

      return updatedOptions;
    });
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTempSelectedOptions([]);
  };

  const handleSubmit = () => {
    setSelectedOptions(tempSelectedOptions);
    dispatch(setSelectedOptionsForFormula({ id: props.id || props?._id, value: tempSelectedOptions }));
    setIsModalOpen(false);
  };

  const removeSelectedOption = (option) => {
    setTempSelectedOptions((prev) => prev.filter((item) => item !== option));
    setSelectedOptions((prev) => prev.filter((item) => item !== option));
    dispatch(setSelectedOptionsForFormula({ id: props.id || props?._id, value: [...selectedOptions.filter((item) => item !== option)] }))
  };

  const resetSelection = () => {
    setSelectedOptions([]);
    setIsModalOpen(true);
  };

  const filteredOptions = props?.data?.options ? props?.data?.options?.filter((option) =>
    option.toLowerCase()?.includes(searchQuery.toLowerCase())
  ) : props?.options?.filter((option) =>
    option.toLowerCase()?.includes(searchQuery.toLowerCase())
  );

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>
            {props?.data?.required && <span style={{ color: "red" }}>*</span>}
            {props?.data?.value || props?.name || props?.label}
          </span>
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>


        {
          props?.allowMultipleAnswers ? selectedOptions?.length === 0 && (
            <div className={styles.selectContainer} onClick={openModal}>
              <div className={styles.selectfield}>
                <span>Select Multiple Options</span>
              </div>
            </div>
          ) : <Select onChange={(e) => {
            setTempSelectedOption(e?.target?.value)
            dispatch(setSelectedOptionsForFormula({ id: props.id || props?._id, value: e?.target?.value }));

          }}>
            {
              props?.options?.map((opt) => {
                return <MenuItem value={opt}>{opt}</MenuItem>

              })

            }
          </Select>
        }
        {/* <Select onChange={(e) => {
          setTempSelectedOption(e?.target?.value)
          dispatch(setSelectedOptionsForFormula({ id: props.id || props?._id, value: e?.target?.value }));

        }}>
          {
            props?.options?.map((opt) => {
              return <MenuItem value={opt}>{opt}</MenuItem>

            })

          }
        </Select> */}

        {isModalOpen && (
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
              <h4>Select Your Options</h4>

              <div className={styles.searchContainer}>
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder="Search options..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              <div className={styles.optionsList}>
                {filteredOptions?.length > 0 ? (
                  filteredOptions.map((option, index) => (
                    <div key={index} className={styles.optionItem}>
                      <input
                        type="checkbox"
                        id={`option-${index}`}
                        checked={tempSelectedOptions?.includes(capitalizeFirstLetter(option))}
                        onChange={() => handleOptionChange(capitalizeFirstLetter(option))}
                      />
                      <label htmlFor={`option-${index}`}>{option}</label>
                    </div>
                  ))
                ) : (
                  <div className={styles.noResults}>No results found</div>
                )}
              </div>

              <div className={styles.modalActions}>
                <button className={styles.cancelButton} onClick={closeModal}>
                  Cancel
                </button>
                <button className={styles.submitButton} onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        {/* After Submit: Selected Options List */}
        {selectedOptions?.length > 0 && (
          <div className={styles.selectedOptionsList}>
            <ul>
              {selectedOptions.map((option, index) => (
                <li key={index} className={styles.selectedOptionItem}>
                  <span>{option}</span>
                  <CrossIcon
                    className={styles.removeIcon}
                    onClick={() => removeSelectedOption(option)}
                  />
                </li>
              ))}
            </ul>

            <div className={styles.selectContainer} onClick={openModal}>
              <div className={styles.selectfield}>
                <span>Select Multiple Options</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>{props?.instructions}</div>
          )}
          {props?.data?.media?.length ? (
            <div className={styles.mediaContent}>
              {props?.data?.media.map((image) => (
                <img
                  key={image.path}
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </div>
          ) : null}
        </div>
      )}
      {
        (tempSelectedOptions?.includes(capitalizeFirstLetter(props?.whenAnswerEquals)) || props?.whenAnswerEquals == "any" && tempSelectedOptions?.length) ? props?.dependentField?.map((ele) => {
          return props?.renderContent(ele)
        }) : null
      }
      {
        (tempSelectedOption?.includes(capitalizeFirstLetter(props?.whenAnswerEquals)) || props?.whenAnswerEquals == "any" && tempSelectedOption?.length) ? props?.dependentField?.map((ele) => {
          return props?.renderContent(ele)
        }) : null
      }
    </div>
  );
};

export default PreviewMultipleChoice;